import { MouseEvent, useState } from "react";
import { IconButton, Menu } from "@mui/material";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

const RowActionsGrid = (params: any) => {
    const [actionAnchor, setActionAnchor] = useState<null | HTMLElement>(null);
    const open = Boolean(actionAnchor);
    const openAction = (event: MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        setActionAnchor(event.currentTarget);
    }
    const closeAction = (event: any) => {
        event.stopPropagation();
        setActionAnchor(null);
    }

    return (
        <>
            <IconButton
                onClick={openAction}
            >
                <MoreHorizIcon />
            </IconButton>
            <Menu
                anchorEl={actionAnchor}
                open={open}
                onClose={closeAction}
                //onClick={params.viewSelect(params.data.id,params.data)}
            >
                <params.actions
                    close={closeAction}
                    viewSelect={params.viewSelect}
                    data={params.data}
                />
            </Menu>
        </>
    )
}

export default RowActionsGrid;